import { message, notification } from 'antd';
import { AxiosInstance } from 'axios';
import { action, observable } from 'mobx';
import { setexpectMultiplier } from '../lib/priceCalculate';
import { getAxiosInstanceWithToken } from '../services/axios';

import { AddLectoTypeProductDto, GetInventoryOutPutDto, LectoTypeProductServiceProxy, LectoTypeServiceProxy, AddLectoTypeProductVcInputDto, LectoTypeProductVcServiceProxy, CopyProductVcsInputDto, ListPriceSeriesServiceProxy, ListPriceBasicPriceDto, AddOrderFormSmartConfiguratorDto, OrderFormServiceProxy, AddCustomProductInPutDto, AddCustomVcInputDto, VcType, ProdcutAndVcSource, SMProduct, SMVC, PreCalServiceProxy, CustomerInfosServiceProxy, FacePriceMatchingInPutDto, FacePriceMatchingProductInPutDto, SetPReCalNumberInPutDto, IndustryVCServiceProxy, TechnologyQuotationStatus, SaleHelpDisCountCompletedInPut, CPQuotedNeedHelpInPut, UserServiceProxy, UnitPriceType, HelpLectoType, BasicMotorInfoServiceProxy, VcInfoServiceProxy, BasicMotorSriesServiceProxy, AddImportProductInputDto, UpdateImportProductInputDto, BasicMotorType, UpdateProductMultiplierDto, ListPriceVcCodeInputDto, CategoryCodeServiceProxy, VCShowType, LectoTypeStatus, VC, JINMotorInsideVcRemarkServiceProxy, UpdateJINInsideVcRemarkInputDto, InsideVcRelType } from '../services/serviceProxy';
import InventoryStatusStore from './inventoryStatusStore';
import { isGranted } from '../lib/abpUtility';
import { getLectoTypeSelectionProductCode } from '../lib/jinProductCode';

const error_noerror: bigint = BigInt(0);
const error_nowires: bigint = BigInt(1 << 0);
const error_unavalible: bigint = BigInt(1 << 1);
const error_incompatible: bigint = BigInt(1 << 2);
const error_required: bigint = BigInt(1 << 3);
const error_resolvable: bigint = BigInt(1 << 4);
const error_freetext: bigint = BigInt(1 << 5);
const error_tech: bigint = BigInt(1 << 6);
const error_elec: bigint = BigInt(1 << 7);
const error_warn: bigint = BigInt(1 << 8);
const error_error: bigint = BigInt(1 << 9);
const error_needgcs: bigint = BigInt(1 << 10);
const error_needRemart: bigint = BigInt(1 << 11);

class budgetQuotationDto extends SMProduct {

}
class InventoryStore {
  inventoryStatusStore: InventoryStatusStore;
  constructor(_inventoryStatusStore: InventoryStatusStore) {
    this.inventoryStatusStore = _inventoryStatusStore;
  }

  @observable inventoryInfo: GetInventoryOutPutDto = new GetInventoryOutPutDto();
  // 品类编号服务对象
  @observable categoryCodeService = new CategoryCodeServiceProxy()

  @observable currentSelectRowIds: React.ReactText[] = [];
  @observable currentSelectRow: SMProduct = new SMProduct();
  @observable currentSelectRows: SMProduct[];

  @observable instance: AxiosInstance = null;

  @observable hasOpenVC = false;
  @observable openVCRemartMissing = false;
  @observable showOpenVCDetailWindow = false;
  /** 产品清单增删改接口进行中（用于禁用「请求协助」等） */
  @observable productListLoadingCount = 0;
  get productListLoading() {
    return this.productListLoadingCount > 0;
  }
  /** 国产报价保存后暂存 DTO，供面价匹配写回时使用 */
  lastSavedDqForFacePrice: any = null;
  @observable facePriceRevision = 0;
  manuallyCloseDetailWindow = () => {
    this.openVCRemartMissing = false;
  }
  updateShowOpenVCDetailWindow = () => {
    this.showOpenVCDetailWindow = false;
  }
  /** 合并 vc + jinVc（内含 VC 拆分在 jinVc，检测 OpenVC 时需一并计入） */
  private getProductAllVcs = (product: SMProduct): SMVC[] => {
    return [...(product.vc || []), ...((product as any).jinVc || [])];
  }

  /**
   * 与产品清单行级只读一致：
   * 订单变更时 GCS/SuperGCS 仅可编辑 changeSelected 且 allowEditing 的行，其余用户仅可编辑 allowEditing 的行。
   */
  canEditProductListRow = (product?: SMProduct) => {
    if (!product) return false;
    if (!this.inventoryInfo.orderChange) return true;
    const hasGCSPower = isGranted("Role.GCS") || isGranted("Role.SuperGCS");
    return !!product.allowEditing && (!hasGCSPower || !!product.changeSelected);
  }

  updateOpenVCState = () => {
    //销售
    const isSales = isGranted("Role.Sales");
    //CP
    const isCP = isGranted("Role.CP");
    // 订单变更且存在 changeSelected=true 时：仅检查已勾选产品；否则检查全部
    const hasChangeSelected = !!this.inventoryInfo.orderChange
      && this.inventoryInfo.products.some(x => x.changeSelected);
    const productsForOpenVcCheck = hasChangeSelected
      ? this.inventoryInfo.products.filter(x => x.changeSelected)
      : this.inventoryInfo.products;
    // 强制补填备注仅针对产品清单可编辑行；只读行仍可打开查看，但不阻断流程
    const productsForOpenVcEdit = productsForOpenVcCheck.filter(x => this.canEditProductListRow(x));
    if (isSales || isCP) {
      //关闭SC销售/cp，编辑openvc163/209
      this.hasOpenVC = productsForOpenVcCheck.filter(x =>
        this.getProductAllVcs(x).filter(y => y.vcShowType != VCShowType.Label && y.vcShowType != VCShowType.UnKnow && y.vcCode != "209" && y.vcCode != "163").length > 0
      ).length > 0

      this.openVCRemartMissing = productsForOpenVcEdit.filter(x => x.checkResultOutput.error.indexOf("开放式选项尚未配置") == -1
        && this.getProductAllVcs(x).filter(y => y.vcShowType != VCShowType.Label && y.vcShowType != VCShowType.UnKnow && !y.remark && y.vcCode != "209" && y.vcCode != "163").length > 0
      ).length > 0;
    } else {
      this.hasOpenVC = productsForOpenVcCheck.filter(x => this.getProductAllVcs(x).filter(y => y.vcShowType != VCShowType.Label && y.vcShowType != VCShowType.UnKnow).length > 0).length > 0
      this.openVCRemartMissing = productsForOpenVcEdit.filter(x => x.checkResultOutput.error.indexOf("开放式选项尚未配置") == -1
        && this.getProductAllVcs(x).filter(y => y.vcShowType != VCShowType.Label && y.vcShowType != VCShowType.UnKnow && !y.remark).length > 0).length > 0;
    }
    this.showOpenVCDetailWindow = this.openVCRemartMissing;
  }

  lec = new LectoTypeServiceProxy();
  ltpsp = new LectoTypeProductServiceProxy();
  ltpvsp = new LectoTypeProductVcServiceProxy();
  pcsp = new PreCalServiceProxy();
  ivcService = new IndustryVCServiceProxy();
  bms = new BasicMotorInfoServiceProxy();
  vcis = new VcInfoServiceProxy();
  lpbm = new ListPriceSeriesServiceProxy();
  bmssp = new BasicMotorSriesServiceProxy();
  jinInsideVcRemarkService = new JINMotorInsideVcRemarkServiceProxy();
  //使用自定义token
  useMyToken = (token: string) => {
    this.instance = getAxiosInstanceWithToken(token);
    this.lec = new LectoTypeServiceProxy(null, this.instance);
    this.ltpsp = new LectoTypeProductServiceProxy(null, this.instance);
    this.ltpvsp = new LectoTypeProductVcServiceProxy(null, this.instance);
    this.pcsp = new PreCalServiceProxy(null, this.instance);
    this.bms = new BasicMotorInfoServiceProxy(null, this.instance);
    this.vcis = new VcInfoServiceProxy(null, this.instance);
    this.lpbm = new ListPriceSeriesServiceProxy(null, this.instance);
    this.bmssp = new BasicMotorSriesServiceProxy(null, this.instance);
    this.jinInsideVcRemarkService = new JINMotorInsideVcRemarkServiceProxy(null, this.instance);
  }

  //获取选型清单
  /**
   * 境界产品字段对调（展示用 ↔ 接口原始值）。
   * GetInventory 后对调供 UI；回传接口前需再对调还原。
   */
  private swapJinProductFields = (product: SMProduct | any) => {
    if (!product?.jinBasicMotorCode || !product?.basicMotorCode) return;

    let tempBasicMotorModel = product.basicMotorModel;
    product.basicMotorModel = product.jinBasicMotorModel;
    product.jinBasicMotorModel = tempBasicMotorModel;

    let tempBasicMotorMounting = product.basicMotorMounting;
    product.basicMotorMounting = product.jinBasicMotorMounting;
    product.jinBasicMotorMounting = tempBasicMotorMounting;

    let tempBasicMotorSries = product.basicMotorSries;
    product.basicMotorSries = product.jinBasicMotorSries;
    product.jinBasicMotorSries = tempBasicMotorSries;

    let tempFrameSize = product.frameSize;
    product.frameSize = product.jinFrameSize;
    product.jinFrameSize = tempFrameSize;

    let tempPower = product.power;
    product.power = product.jinPower;
    product.jinPower = tempPower;

    let tempBasicMotorCode = product.basicMotorCode;
    product.basicMotorCode = product.jinBasicMotorCode;
    product.jinBasicMotorCode = tempBasicMotorCode;

    let tempMultipilerType = product.multipilerType;
    product.multipilerType = product.jinMultipilerType;
    product.jinMultipilerType = tempMultipilerType;

    let tempUnitPrice = product.unitPrice;
    product.unitPrice = product.jinUnitPrice;
    product.jinUnitPrice = tempUnitPrice;
  }

  /** 处理 GetInventory 返回的产品/VC 结构（jinVc 拆分、境界码交换等） */
  private processInventoryProducts(data: GetInventoryOutPutDto) {
    data.products.forEach(product => {
      product.jinVc = product.vc.filter(x => x.isInside);
      product.vc = product.vc.filter(x => !x.isInside);
      this.swapJinProductFields(product);
    });
  }

  /** 静默拉取最新选型清单，不更新 store（供国产报价保存前组装 create 入参） */
  @action
  async fetchLatestInventory(lectoTypeId: string): Promise<GetInventoryOutPutDto> {
    const data = await this.lec.getInventory(lectoTypeId);
    if ((data.status == LectoTypeStatus.NeedGCSHelp || data.status == LectoTypeStatus.GCSHelping) && !(isGranted("Role.GCS") || isGranted("Role.SuperGCS"))) {
      message.warning("选型正在协助中",)
      setTimeout(() => {
        window.location.href = `/LectoType/Details/${data.id}`
      }, 2000);
      return Promise.reject(false);
    }
    this.processInventoryProducts(data);
    return data;
  }

  @action
  async getDetails(lectoTypeId: string) {
    const data = await this.lec.getInventory(lectoTypeId);
    if ((data.status == LectoTypeStatus.NeedGCSHelp || data.status == LectoTypeStatus.GCSHelping) && !(isGranted("Role.GCS") || isGranted("Role.SuperGCS"))) {
      message.warning("选型正在协助中",)
      // 2秒后刷新当前页面
      setTimeout(() => {
        window.location.href = `/LectoType/Details/${data.id}`
      }, 2000); // 2000 毫秒 = 2 秒

      return Promise.reject(false);
    } else {
      this.processInventoryProducts(data);
      this.inventoryInfo = data;
      this.updateOpenVCState();
      this.inventoryStatusStore.setDqState(data.dq?.dqStatus ?? TechnologyQuotationStatus.UnKnow);
      if (this.inventoryInfo.pmsProjectType == 1) {
        this.inventoryInfo.products.map(p => {
          if (p.dqProduct) {
              this.inventoryStatusStore.setPMSDqState(true);
          }
        })
        this.inventoryStatusStore.setPMSDqState(false);
      }
      this.inventoryStatusStore.setTeState(data.te?.teStatus ?? TechnologyQuotationStatus.UnKnow);
      this.inventoryStatusStore.setPMSType(data.pmsProjectType ?? 0);
      this.inventoryStatusStore.setJinLectoType(data.jinLectoType ?? false);
      this.inventoryStatusStore.setInvState(data.status);
      this.inventoryStatusStore.setInvClientId(data.clientID, data.responsibleSalesCode);
      this.resetCurrentSelectRows()

      this.inventoryStatusStore.setAllInvState(data.dq?.dqStatus ?? TechnologyQuotationStatus.UnKnow,
        data.te?.teStatus ?? TechnologyQuotationStatus.UnKnow,
        data.status, data.clientID);
      if (this.inventoryInfo && this.inventoryInfo.products &&
        this.inventoryInfo.products.length > 0 &&
        this.inventoryInfo.products.filter(x => x.vc.filter(y => y.vcType == VcType.Custom).length > 0).length > 0) {
        const productsToValidate = this.inventoryInfo.orderChange
          ? this.inventoryInfo.products.filter(p => p.changeSelected)
          : this.inventoryInfo.products;
        const allProductsValid = productsToValidate.filter(x => x.basicMotorType != BasicMotorType.Import)
          .every(product => {
            // 检查每个 product 的 dqProduct 是否不为空，并且 dqStatus 等于 ExamineSuccess
            // !product.dqProduct 为空时，必须保证VC集合中不包含自定义VC，存在自定义VC时，产品必须要有报价
            const isDqProductValid = (!product.dqProduct && product.vc.every(vcItem =>
              vcItem.vcType !== VcType.Custom)) || (product.dqProduct &&
                product.dqProduct.technologyQuotation &&
                (product.dqProduct.technologyQuotation.dqStatus === TechnologyQuotationStatus.ExamineSuccess ||
                  product.dqProduct.technologyQuotation.dqStatus === TechnologyQuotationStatus.Completed
                ));

            // 检查 vc 数组中是否所有 Custom 类型的 vc 都有 dqStatus 等于 ExamineSuccess
            // 当VC类型为自定义VC时，检查国产报价与选型中VC编号是否一致、产品代码是否一致
            // 检查VC代码是否一致，是因为在选型中编号有可能会被修改，比如国产报价中编码为999的VC，会被更新成新的编码，此类数据需要生成全新的国产报价才可以转交选型
            // 检查产品代码是否一致，是因为会存在复制VC的情况，将包含在国产报价中的VC复制至一个全新的产品中，此类数据需要生成全新的国产报价才可以转交选型
            const areAllCustomVcsValid = product.vc.every(vcItem =>
              vcItem.vcType !== VcType.Custom ||
              (vcItem.dqProductVc &&
                vcItem.dqProductVc.vcID == vcItem.vcCode &&
                vcItem.dqProductVc.dqProduct &&
                vcItem.dqProductVc.dqProduct.basicMotorCode == product.basicMotorCode &&
                vcItem.dqProductVc.dqProduct.technologyQuotation &&
                (vcItem.dqProductVc.dqProduct.technologyQuotation.dqStatus === TechnologyQuotationStatus.ExamineSuccess ||
                  vcItem.dqProductVc.dqProduct.technologyQuotation.dqStatus === TechnologyQuotationStatus.Completed
                ))
            );

            return isDqProductValid && areAllCustomVcsValid;
          });
        this.inventoryStatusStore.setInvHasIssue(allProductsValid);
      } else {
        this.inventoryStatusStore.setInvHasIssue(true);
      }
    }

    return Promise.resolve(true);
  }

  //添加主机
  @action
  async addBasicMotor(data: AddLectoTypeProductDto) {
    data.lectoTypeId = this.inventoryInfo.id
    if (this.currentSelectRows != null && this.currentSelectRows.length == 1) {
      data.serialNo = this.currentSelectRow.serialNo + 1
    }
    this.productListLoadingCount++;
    try {
      await this.ltpsp.add(data);
      await this.getDetails(this.inventoryInfo.id);
    } finally {
      this.productListLoadingCount = Math.max(0, this.productListLoadingCount - 1);
    }
  }

  //设置当前选中行
  @action
  async setCurrentSelectRowIds(currentSelectRowIds: React.ReactText[], selectedRows: SMProduct[]) {
    this.currentSelectRowIds = currentSelectRowIds;
    this.currentSelectRows = selectedRows;
    if (currentSelectRowIds.length == 1) {
      this.currentSelectRow = selectedRows[0];
    }
  }

  // 重置选型中的产品信息
  @action
  async resetCurrentSelectRows() {
    this.currentSelectRows = this.inventoryInfo.products.filter(x => this.currentSelectRowIds.indexOf(x.id) > -1);
    if (this.currentSelectRowIds.length == 1) {
      this.currentSelectRow = this.currentSelectRows.find(x => x.id == this.currentSelectRow.id)
    }
  }

  @action
  async getVcCodes() {
    if (this.currentSelectRows.length == 1) {
      let getVcCodesInputDto = new ListPriceVcCodeInputDto();
      getVcCodesInputDto.frameNumber = this.currentSelectRow.frameSize
      getVcCodesInputDto.seriesName = this.currentSelectRow.basicMotorSries
      return await this.lpbm.getVcCode(getVcCodesInputDto)
    } else {
      let getVcCodesInputDtos = [];

      this.currentSelectRows.forEach(Row => {
        let getVcCodesInputDto = new ListPriceVcCodeInputDto();
        getVcCodesInputDto.frameNumber = Row.frameSize
        getVcCodesInputDto.seriesName = Row.basicMotorSries
        getVcCodesInputDtos.push(getVcCodesInputDto)
      });

      return await this.lpbm.getVcCodes(getVcCodesInputDtos)
    }
  }

  @action
  async addVc(vcId: string, vcProductCode: string) {
    if (this.currentSelectRowIds.length === 0) {
      notification.info({ message: '请至少选择一个电机' })
      return;
    }
    let customCount = this.currentSelectRows.filter(x => x.basicMotorType == BasicMotorType.Custom).length
    // 包含自定义电机时,验证Vc长代码
    if (customCount > 0) {

      if (!vcProductCode || vcProductCode.length < 12) {
        notification.info({
          message: '自定义电机添加标准Vc',
          description: '自定义电机添加标准Vc时需要单独选中查询Vc信息,',
          duration: 4.5,
        });

        return
      }
    }

    if (this.currentSelectRows) {
      let currentSelectRowIds = this.currentSelectRowIds.map(x => x);

      if (currentSelectRowIds.length === 0) {
        return;
      }

      this.productListLoadingCount++;
      try {
        let result = await this.ltpvsp.add({
          lectoTypeProductIds: currentSelectRowIds,
          vcInfoId: vcId,
          vcProductCode: vcProductCode
        } as AddLectoTypeProductVcInputDto);
        await this.getDetails(this.inventoryInfo.id);
        notification.success({ message: 'VC添加成功' })
        if (result) {
          var msgs = result.split("。");
          if (msgs.length > 0) {
            for (let index = 0; index < msgs.length; index++) {
              if (msgs[index]) notification.warn({ message: msgs[index] });
            }
          }
        }
      } finally {
        this.productListLoadingCount = Math.max(0, this.productListLoadingCount - 1);
      }
    }
  }

  @action
  async delVc(id: string) {
    this.productListLoadingCount++;
    try {
      await this.ltpvsp.delete(id);
      await this.getDetails(this.inventoryInfo.id);
      notification.success({ message: '删除成功' })
    } finally {
      this.productListLoadingCount = Math.max(0, this.productListLoadingCount - 1);
    }
  }

  @action
  async delVcs(ids: string[], customVcCodes: string[] = []) {
    if (ids.length === 0) return;
    this.productListLoadingCount++;
    try {
      await this.ltpvsp.batchDelete({ ids });
      await this.getDetails(this.inventoryInfo.id);
      [...new Set(customVcCodes)].forEach(vcCode => {
        if (this.isUnLockByCustomVcCode(vcCode)) {
          this.categoryCodeService.unLockByCode(vcCode);
        }
      });
    } finally {
      this.productListLoadingCount = Math.max(0, this.productListLoadingCount - 1);
    }
  }

  // 是否允许释放自定义VC编号
  isUnLockByCustomVcCode(vcCode: string) {
    return this.inventoryInfo.products.filter(x => x.vc.filter(v => v.vcType == VcType.Custom && v.vcCode == vcCode).length > 0).length == 0
  }

  @action
  async delBasicMotor(ids: string[]) {
    this.productListLoadingCount++;
    try {
      await this.ltpsp.delete(this.inventoryInfo.id, ids);
      const currentSelectRows = this.currentSelectRows
      await this.getDetails(this.inventoryInfo.id);
      // 初始化一个集合用于存储需要释放的VC编号
      let removeVcCodes = new Set<string>();
      currentSelectRows.forEach(record => {
        // 释放产品下的自定义VC编号
        if (record.vc && record.vc.filter(x => x.vcType == VcType.Custom).length > 0) {
          record.vc.filter(x => x.vcType == VcType.Custom).map(x => x.vcCode).forEach(x => {
            // 检查是否有其他产品仍在使用此VC编号
            const isVcCodeInUse = this.inventoryInfo.products.some(
              product => product.id !== record.id &&
                product.vc.some(v => v.vcType === VcType.Custom && v.vcCode === x)
            );

            // 如果没有其他产品使用此VC编号，则添加到移除列表
            if (!isVcCodeInUse) {
              removeVcCodes.add(x);
            }
          })
        }
      })

      this.currentSelectRowIds = []

      if (removeVcCodes.size > 0) this.categoryCodeService.unLockByCodes(Array.from(removeVcCodes))

      notification.success({ message: '删除成功' })
    } finally {
      this.productListLoadingCount = Math.max(0, this.productListLoadingCount - 1);
    }
  }

  @action
  async copyBasicMotor(id: string) {
    await this.ltpsp.copy(id);
    await this.getDetails(this.inventoryInfo.id);
    notification.success({ message: '复制成功' })
  }

  //根据产品编号顺序设置序号属性
  @action
  async setProductSerialNo(newDataSource: SMProduct[]) {
    await this.ltpsp.setProductSerialNo(newDataSource.map(x => x.id));
    await this.getDetails(this.inventoryInfo.id);
  }

  //修改产品数量
  @action
  async updateProductNumber(id: string, number: number) {
    await this.ltpsp.updateProductNumber(id, number);
    await this.getDetails(this.inventoryInfo.id);
  }

  //修改产品技术确认号
  @action
  async updateProductTechnicalConfirmation(id: string, technicalConfirmation: string) {
    await this.ltpsp.updateProductTechnicalConfirmation(id, technicalConfirmation);
    await this.getDetails(this.inventoryInfo.id);
  }

  //修改产品交期评审号
  @action
  async updateProductAppraisalNumber(id: string, appraisalNumber: string) {
    await this.ltpsp.updateProductAppraisalNumber(id, appraisalNumber);
    await this.getDetails(this.inventoryInfo.id);
  }

  //修改产品技术协议号
  @action
  async updateProductTechnicalSpecifications(id: string, technicalSpecifications: string) {
    await this.ltpsp.updateProductTechnicalSpecifications(id, technicalSpecifications)
      .finally(async () => {
        await this.getDetails(this.inventoryInfo.id);
      });
  }

  //修改本地缓存产品技术协议号
  @action
  updateLocalProductTechnicalSpecifications(id: string, technicalSpecifications: string): void {
    const product = this.inventoryInfo.products.find(x => x.id == id)
    if (product) product.technicalSpecification = technicalSpecifications
  }

  @action
  async copyProductVcs(idGo: string, idEnds: string[]) {
    await this.ltpsp.copyProductVcs({
      lectoTypeProductIdGo: idGo,
      lectoTypeProductIdEnds: idEnds
    } as CopyProductVcsInputDto);
    await this.getDetails(this.inventoryInfo.id);
    notification.success({ message: '复制成功' })
  }

  @action
  async copyVc(lectoTypeProductVcId: string, lectoTypeProductIdEnds: string[]) {
    await this.ltpvsp.copyVc(lectoTypeProductVcId, lectoTypeProductIdEnds);
    await this.getDetails(this.inventoryInfo.id);
    notification.success({ message: '复制成功' })
  }

  /** 记录刚保存的国产报价，facePriceMatching 在 getDetails 后优先应用 */
  @action
  setLastSavedDqForFacePrice(dq: any) {
    this.lastSavedDqForFacePrice = dq ? JSON.parse(JSON.stringify(dq)) : null;
  }

  private normalizePriceValue(value: string | number | undefined | null) {
    if (value === undefined || value === null || value === '') {
      return undefined;
    }
    const num = Number(value);
    return Number.isNaN(num) ? value : num;
  }

  /**
   * 获取用于与 dqProduct.basicMotorCode 比对的「选型产品代码」。
   * 原始返回：jinBasicMotorCode 有值取 jin，否则取 basicMotorCode；inventory 已对调故 fieldsSwapped=true。
   */
  private getLectoTypeMotorCodeForDqMatch(product: SMProduct | any): string | undefined {
    return getLectoTypeSelectionProductCode(product, true);
  }

  /** 选型主机代码与国产报价主机代码一致时，才允许用国产报价面价覆盖选型电机面价 */
  private isDqBasicMotorCodeMatched(product: SMProduct | any, dqProduct: any) {
    const lectoTypeCode = this.getLectoTypeMotorCodeForDqMatch(product);
    const dqCode = dqProduct?.basicMotorCode;
    if (!lectoTypeCode || !dqCode) {
      return false;
    }
    return String(lectoTypeCode) === String(dqCode);
  }

  /** 将保存的国产报价 DTO 直接同步到选型，避免 API 回读/境界码交换导致字段丢失 */
  @action
  applySavedDqToFacePrice(dq: any) {
    if (!dq?.technologyQuotationProducts?.length || !this.inventoryInfo?.products?.length) {
      return;
    }
    const applyDqVcFields = (vc: SMVC, dqVc: any) => {
      const discountType = dqVc.discountType;
      if (discountType !== undefined && discountType !== null && discountType !== '') {
        const normalizedDiscountType = Number(discountType);
        vc.discountType = normalizedDiscountType;
        if (vc.vcType === VcType.Industry) {
          (vc as any).unitPriceType = normalizedDiscountType;
        }
        if ((vc as any).dqProductVc) {
          (vc as any).dqProductVc.unitPriceType = normalizedDiscountType;
          (vc as any).dqProductVc.discountType = normalizedDiscountType;
        }
      }
      const unitPrice = this.normalizePriceValue(dqVc.unitPrice);
      if (unitPrice !== undefined) {
        vc.unitPrice = unitPrice;
        if ((vc as any).dqProductVc) {
          (vc as any).dqProductVc.unitPrice = unitPrice;
        }
      }
      if (dqVc.unitPriceFormula !== undefined && dqVc.unitPriceFormula !== null) {
        (vc as any).unitPriceFormula = dqVc.unitPriceFormula;
        if ((vc as any).dqProductVc) {
          (vc as any).dqProductVc.unitPriceFormula = dqVc.unitPriceFormula;
        }
      }
      const cost = this.normalizePriceValue(dqVc.cost);
      if (cost !== undefined) {
        (vc as any).cost = cost;
        if ((vc as any).dqProductVc) {
          (vc as any).dqProductVc.cost = cost;
        }
      }
      if (dqVc.costFormula !== undefined && dqVc.costFormula !== null) {
        (vc as any).costFormula = dqVc.costFormula;
        if ((vc as any).dqProductVc) {
          (vc as any).dqProductVc.costFormula = dqVc.costFormula;
        }
      }
      if (dqVc.costType !== undefined && dqVc.costType !== null) {
        (vc as any).costType = dqVc.costType;
        if ((vc as any).dqProductVc) {
          (vc as any).dqProductVc.costType = dqVc.costType;
        }
      }
      if (dqVc.costTypeDetail !== undefined && dqVc.costTypeDetail !== null) {
        (vc as any).costTypeDetail = dqVc.costTypeDetail;
        if ((vc as any).dqProductVc) {
          (vc as any).dqProductVc.costTypeDetail = dqVc.costTypeDetail;
        }
      }
      if (dqVc.quotationPrinciple !== undefined && dqVc.quotationPrinciple !== null) {
        (vc as any).quotationPrinciple = dqVc.quotationPrinciple;
        if ((vc as any).dqProductVc) {
          (vc as any).dqProductVc.quotationPrinciple = dqVc.quotationPrinciple;
        }
      }
      if (dqVc.quotationPrincipleDetails !== undefined && dqVc.quotationPrincipleDetails !== null) {
        (vc as any).quotationPrincipleDetails = dqVc.quotationPrincipleDetails;
        if ((vc as any).dqProductVc) {
          (vc as any).dqProductVc.quotationPrincipleDetails = dqVc.quotationPrincipleDetails;
        }
      }
    };
    dq.technologyQuotationProducts.forEach((dqProduct: any) => {
      const product = this.inventoryInfo.products.find((p) => String(p.id) === String(dqProduct.lectoTypeProductId));
      if (!product) {
        return;
      }
      if (this.isDqBasicMotorCodeMatched(product, dqProduct)) {
        if (dqProduct.unitPrice !== undefined && dqProduct.unitPrice !== null) {
          product.unitPrice = dqProduct.unitPrice;
        }
        if (dqProduct.unitPriceFormula !== undefined && dqProduct.unitPriceFormula !== null) {
          (product as any).unitPriceFormula = dqProduct.unitPriceFormula;
        }
        if (dqProduct.cost !== undefined && dqProduct.cost !== null) {
          (product as any).cost = dqProduct.cost;
        }
        if (dqProduct.costFormula !== undefined && dqProduct.costFormula !== null) {
          (product as any).costFormula = dqProduct.costFormula;
        }
        if (dqProduct.costType !== undefined && dqProduct.costType !== null) {
          (product as any).costType = dqProduct.costType;
        }
        if (dqProduct.dqRemark !== undefined && dqProduct.dqRemark !== null) {
          (product as any).dqRemark = dqProduct.dqRemark;
        }
      }
      dqProduct.technologyQuotationProductVCs?.forEach((dqVc: any) => {
        const vcId = dqVc.lectoTypeProductVCId;
        if (!vcId) {
          return;
        }
        const targets = [
          product.vc?.find((v) => String(v.id) === String(vcId)),
          product.jinVc?.find((v) => String(v.id) === String(vcId)),
        ].filter(Boolean) as SMVC[];
        targets.forEach((vc) => applyDqVcFields(vc, dqVc));
      });
    });
    this.facePriceRevision += 1;
  }

  /** 将当前国产报价中的面价/打折方式等字段同步回选型 VC，供面价单展示与持久化 */
  @action
  syncDomesticQuotationToFacePrice() {
    if (!this.inventoryInfo?.products?.length) {
      return;
    }
    const isSameProductRef = (dqProduct: any, product: SMProduct) => {
      if (!dqProduct) {
        return false;
      }
      const productCodes = new Set(
        [product.basicMotorCode, product.jinBasicMotorCode, product.dqProduct?.basicMotorCode, dqProduct.basicMotorCode]
          .filter(Boolean)
          .map(String),
      );
      if (dqProduct.basicMotorCode && productCodes.size > 0) {
        return productCodes.has(String(dqProduct.basicMotorCode));
      }
      return true;
    };
    const syncVcFromDqProductVc = (vc: SMVC, product: SMProduct) => {
      const dqVc = vc.dqProductVc as any;
      if (!dqVc) {
        return;
      }
      if (dqVc.lectoTypeProductVCId && String(dqVc.lectoTypeProductVCId) !== String(vc.id)) {
        return;
      }
      const dqProduct = dqVc.dqProduct ?? product.dqProduct;
      if (!isSameProductRef(dqProduct, product)) {
        return;
      }
      if (dqVc.vcID && vc.vcCode && dqVc.vcID !== vc.vcCode) {
        return;
      }
      // 手动填价 VC（如船检费/细检费，unitPriceResult=M）以面价单保存为准，勿被国产报价旧值覆盖
      if (vc.unitPriceResult !== 'M') {
        const discountType = dqVc.unitPriceType ?? dqVc.discountType;
        if (discountType !== undefined && discountType !== null && discountType !== '') {
          const normalizedDiscountType = Number(discountType);
          vc.discountType = normalizedDiscountType;
          if (vc.vcType === VcType.Industry) {
            (vc as any).unitPriceType = normalizedDiscountType;
          }
        }
        const unitPrice = this.normalizePriceValue(dqVc.unitPrice);
        if (unitPrice !== undefined) {
          vc.unitPrice = unitPrice;
        }
        if (dqVc.unitPriceFormula !== undefined && dqVc.unitPriceFormula !== null) {
          (vc as any).unitPriceFormula = dqVc.unitPriceFormula;
        }
      }
      if (dqVc.cost !== undefined && dqVc.cost !== null && dqVc.cost !== '') {
        (vc as any).cost = dqVc.cost;
      }
      if (dqVc.costFormula !== undefined && dqVc.costFormula !== null) {
        (vc as any).costFormula = dqVc.costFormula;
      }
      if (dqVc.costType !== undefined && dqVc.costType !== null) {
        (vc as any).costType = dqVc.costType;
      }
      if (dqVc.costTypeDetail !== undefined && dqVc.costTypeDetail !== null) {
        (vc as any).costTypeDetail = dqVc.costTypeDetail;
      }
      if (dqVc.quotationPrinciple !== undefined && dqVc.quotationPrinciple !== null) {
        (vc as any).quotationPrinciple = dqVc.quotationPrinciple;
      }
      if (dqVc.quotationPrincipleDetails !== undefined && dqVc.quotationPrincipleDetails !== null) {
        (vc as any).quotationPrincipleDetails = dqVc.quotationPrincipleDetails;
      }
    };
    this.inventoryInfo.products.forEach((product) => {
      if (product.dqProduct) {
        const dqProduct = product.dqProduct;
        if (this.isDqBasicMotorCodeMatched(product, dqProduct)) {
          if (dqProduct.unitPrice !== undefined && dqProduct.unitPrice !== null) {
            product.unitPrice = dqProduct.unitPrice;
          }
          if (dqProduct.unitPriceFormula !== undefined && dqProduct.unitPriceFormula !== null) {
            (product as any).unitPriceFormula = dqProduct.unitPriceFormula;
          }
          if (dqProduct.cost !== undefined && dqProduct.cost !== null) {
            (product as any).cost = dqProduct.cost;
          }
          if (dqProduct.costFormula !== undefined && dqProduct.costFormula !== null) {
            (product as any).costFormula = dqProduct.costFormula;
          }
          if (dqProduct.costType !== undefined && dqProduct.costType !== null) {
            (product as any).costType = dqProduct.costType;
          }
          if (dqProduct.dqRemark !== undefined && dqProduct.dqRemark !== null) {
            (product as any).dqRemark = dqProduct.dqRemark;
          }
        }
      }
      product.vc?.forEach((vc) => syncVcFromDqProductVc(vc, product));
      product.jinVc?.forEach((vc) => syncVcFromDqProductVc(vc, product));
    });
    this.facePriceRevision += 1;
  }

  //面价匹配
  @action
  async facePriceMatching(skipUpdate = false) {
    // 与 master 一致：M 类 VC（船检费等）保存后刷新时，保留面价单上刚编辑的价格/打折类型
    const pendingMVcFields = new Map<string, { discountType?: any; unitPrice?: any }>();
    if (skipUpdate) {
      this.inventoryInfo.products.forEach((product) => {
        const collect = (list?: SMVC[]) => {
          list?.forEach((vc) => {
            if (vc.unitPriceResult === 'M') {
              pendingMVcFields.set(String(vc.id), {
                discountType: vc.discountType,
                unitPrice: vc.unitPrice,
              });
            }
          });
        };
        collect(product.vc);
        collect(product.jinVc);
      });
    }

    const restorePendingMVcFields = () => {
      if (!skipUpdate || pendingMVcFields.size === 0) {
        return;
      }
      this.inventoryInfo.products.forEach((product) => {
        const restore = (list?: SMVC[]) => {
          list?.forEach((vc) => {
            const pending = pendingMVcFields.get(String(vc.id));
            if (!pending || vc.unitPriceResult !== 'M') {
              return;
            }
            if (pending.discountType !== undefined && pending.discountType !== null && pending.discountType !== '') {
              vc.discountType = pending.discountType;
            }
            if (pending.unitPrice !== undefined && pending.unitPrice !== null && pending.unitPrice !== '') {
              vc.unitPrice = pending.unitPrice;
            }
          });
        };
        restore(product.vc);
        restore(product.jinVc);
      });
    };

    if (!skipUpdate) {
      var copyInventoryInfo: GetInventoryOutPutDto = JSON.parse(JSON.stringify(this.inventoryInfo));

      // 过滤进口电机及零部件
      copyInventoryInfo.products = copyInventoryInfo.products.filter(x => x.basicMotorType != BasicMotorType.Import);
      if (copyInventoryInfo.products && copyInventoryInfo.products.length > 0) {
        copyInventoryInfo.products.forEach(p => {
          p.vc = p.vc.filter(x => x.vcType == VcType.Standard)
          if (p.vc && p.vc.length > 0) {
            p.vc.forEach(v => {
              // 标准VC清空价格，匹配最新的价格匹配情况
              v.unitPrice = 0;
              v.unitPriceResult = null
            });
          }
        });
      }
      if (copyInventoryInfo.products && copyInventoryInfo.products.length > 0) {
        const listPriceDto = ListPriceBasicPriceDto.fromJS(copyInventoryInfo)
        if (copyInventoryInfo.finalCustomerCode) listPriceDto.clientID = copyInventoryInfo.finalCustomerCode
        listPriceDto.products.map(x => {
          x.unitPrice = (this.inventoryInfo.orderChange ? x.unitPrice : 0),
            x.unitPriceResult = (this.inventoryInfo.orderChange ? x.unitPriceResult : null),
            x.version = x.jinVersion
        });
        // 一次性项目代码以 GetInventory 的 jinCategoryCode 为准；J4. 开头不参与面价匹配
        listPriceDto.products = (listPriceDto.products || []).filter((product) => {
          const inventoryProduct = (this.inventoryInfo.products || []).find(
            (p) => String(p.id) === String(product.id)
          );
          const categoryCode = inventoryProduct?.jinCategoryCode;
          return !categoryCode?.startsWith('J4.');
        });
        if (listPriceDto.products.length > 0) {
        const data = await this.lpbm.getListPrice(listPriceDto);

        //构建面价传入dto
        let facePriceProuct: FacePriceMatchingProductInPutDto[] = [];
        let facePriceVc: FacePriceMatchingProductInPutDto[] = [];

        (data.products || []).forEach(p => {
          const originData = copyInventoryInfo.products.find(x => x.lectoTypeCustomProductPrice?.lectoTypeProductId === p.id);
          // 为避免失效电机匹配到失效前的价格，移除下面判断条件，排除订单变更场景
          if (
            !this.inventoryInfo.orderChange &&
            (!(p.unitPriceResult === null || p.unitPriceResult === "NULL" || p.unitPriceResult === 'R') || (p.unitPriceResult === "NULL" && p.basicMotorType == BasicMotorType.Custom))
          ) {
            if (originData && originData.basicMotorType == BasicMotorType.Custom) {
              // 自定义产品产品替换价格来源于选型中的价格，而非列表价接口返回的价格
              if (originData) {
                facePriceProuct.push({
                  id: p.id,
                  unitPrice: originData.lectoTypeCustomProductPrice.unitPrice,
                  unitPriceResult: p.unitPriceResult
                } as FacePriceMatchingProductInPutDto);
              }
            } else {
              facePriceProuct.push({
                id: p.id,
                unitPrice: p.unitPrice,
                unitPriceResult: p.unitPriceResult
              } as FacePriceMatchingProductInPutDto);
            }
          }

          p.vc.forEach(v => {
            if (v.unitPriceResult === "M") {
              var unitPrice = this.inventoryInfo.products.find(prod => prod.id === p.id).vc.find(vc => vc.id === v.id).unitPrice;
              //646特殊，当vccode=646，并且类型为M的时候，让用户可以选是否打折
              // 价格不为空为使用填入的价格，不在重新匹配
              if (!unitPrice) {
                facePriceVc.push({
                  id: v.id,
                  unitPrice: unitPrice,
                  unitPriceResult: v.unitPriceResult,
                  vcProductCode: v.vcProductCode,
                  unitPriceType: v.discountType
                } as FacePriceMatchingProductInPutDto);
              }
            } else if (!(v.unitPriceResult === null || v.unitPriceResult === "NULL" || v.unitPriceResult === 'R')) {
              if (!copyInventoryInfo.orderChange && originData && originData.basicMotorType == BasicMotorType.Custom) {
                const originVc = originData.vc.find(vc => vc.id === v.id);
                if (originVc.dqProductVc?.unitPrice) {
                  v.unitPriceResult = 'Y'
                  v.unitPrice = originVc.dqProductVc.unitPrice
                }
                facePriceVc.push({
                  id: v.id,
                  unitPrice: v.unitPrice,
                  unitPriceResult: v.unitPriceResult,
                  vcProductCode: v.vcProductCode,
                  unitPriceType: v.discountType
                } as FacePriceMatchingProductInPutDto);
              } else {
                if (copyInventoryInfo.orderChange) {
                  var currentProduct = this.inventoryInfo.products.find(x => x.id === p.id).vc.find(x => x.id === v.id);
                  if (currentProduct.unitPrice == null) {
                    facePriceVc.push({
                      id: v.id,
                      unitPrice: v.unitPrice,
                      unitPriceResult: v.unitPriceResult,
                      vcProductCode: v.vcProductCode,
                      unitPriceType: v.discountType
                    } as FacePriceMatchingProductInPutDto);
                  }
                } else {
                  facePriceVc.push({
                    id: v.id,
                    unitPrice: v.unitPrice,
                    unitPriceResult: v.unitPriceResult,
                    vcProductCode: v.vcProductCode,
                    unitPriceType: v.discountType
                  } as FacePriceMatchingProductInPutDto);
                }
              }
            }

            // 标准VC回写最新的价格匹配情况
            const product = copyInventoryInfo.products.find(x => x.id === p.id);
            const stnd = product?.vc?.find(x => x.id === v.id);

            if (stnd?.vcType === VcType.Standard && (!v.unitPriceResult || ['NULL', 'R'].includes(v.unitPriceResult))) {
              //自定义产品有价格unitPriceResult为Y
              if (originData && originData.basicMotorType == BasicMotorType.Custom) {
                const originVc = originData.vc.find(vc => vc.id === v.id);
                if (originVc.dqProductVc && originVc.dqProductVc?.unitPrice !== null) {
                  v.unitPriceResult = 'Y'
                  v.unitPrice = originVc.dqProductVc.unitPrice
                }
              }
              // 未匹配到有效面价（null/NULL/R）时勿把列表价占位价（如 999999）写入库，
              // 否则 getDetails 会再次带回这些无效价格，关闭国产报价弹窗后出现“闪价”
              if (!v.unitPriceResult || ['NULL', 'R'].includes(v.unitPriceResult)) {
                v.unitPrice = null
              }
              facePriceVc.push({
                id: v.id,
                unitPrice: v.unitPrice,
                unitPriceResult: v.unitPriceResult,
                vcProductCode: v.vcProductCode,
                unitPriceType: v.discountType
              } as FacePriceMatchingProductInPutDto);
            }
          })
        });
        //往数据库写入面价
        await this.lec.facePriceMatching({
          products: facePriceProuct,
          vcs: facePriceVc
        } as FacePriceMatchingInPutDto);
        }
      }
    }

    await this.getDetails(this.inventoryInfo.id);
    this.syncDomesticQuotationToFacePrice();
    restorePendingMVcFields();

    const warn = [];
    const error = [];
    let mVcPriceIsNull = false;

    // 检查所有价格为NULL或R的标准电机和标准VC
    // 检查所有非标准的电机和VC
    // 如果上面两种东西任意一个没有对应的报价号和价格，则必须生成报价
    // 否则可选生成报价
    this.inventoryInfo.products.filter(x => x.basicMotorType != BasicMotorType.Import).map((product, index) => {
      // 报价前自定义电机：unitPrice 可能为 0，实际面价在 lectoTypeCustomProductPrice 中
      if (
        (product.unitPrice == null || product.unitPrice === 0) &&
        product.lectoTypeCustomProductPrice?.unitPrice != null &&
        !product.dqProduct?.technologyQuotation?.domesticQuotationNumber
      ) {
        product.unitPrice = product.lectoTypeCustomProductPrice.unitPrice;
      }
      // 匹配电机面价
      // var prodUnit = data.products.find(lpProd => lpProd.id == product.id)
      // product.unitPrice = prodUnit.unitPrice;
      // product.unitPriceResult = prodUnit.unitPriceResult
      // 面价没有结果,且没有关联的报价号
      // 非标准电机面价系统会返回”NULL“
      if (product.unitPriceResult === null || product.unitPriceResult === "NULL" || product.unitPriceResult === 'R') {
        if (product.dqProduct?.technologyQuotation?.domesticQuotationNumber != undefined && product.dqProduct?.technologyQuotation?.domesticQuotationNumber != null) {
          // product.edgv = "1";
          // 面价没有，但是关联的报价单里有
          // 这种情况可能是这个产品是从某个报价单参考选型来的
          if (this.isDqBasicMotorCodeMatched(product, product.dqProduct)) {
            product.unitPrice = product.dqProduct.unitPrice;
          }
        } else {
          // 所有地方都没有价格，必须GCS提供
          // 不生成报价不能进行下一步。给一条提示说”该选型包含未报价产品，必须由GCS报价“
          // needQutation = true;
          if (product.basicMotorType == BasicMotorType.Custom) {
            const message = `该选型包含未报价产品${product.basicMotorCode}, 必须由GCS报价`
            if (warn.indexOf(message) == -1) {
              warn.push(message);
            }
          } else {
            const message = `该选型包含未报价产品${product.basicMotorCode} ，必须通过自定义电机的方式添加该产品然后由GCS进行报价`
            if (error.indexOf(message) == -1) {
              error.push(message);
            }
          }
        }
      }
      product.vc.map((vc, index) => {

        //如果是行业VC，则直接取当前值
        if (vc.unitPriceResult === null || vc.unitPriceResult === "NULL" || vc.unitPriceResult === 'R' || vc.isInside) {
          // 行业VC：面价来自行业VC库/选型已有值，无 dqProductVc 时也必须保留，不可当标准VC清空
          if (vc.vcType === VcType.Industry && !vc.isInside) {
            if (vc.unitPrice == null || vc.unitPrice === undefined || vc.unitPrice === '') {
              const message = `该选型包含未报价产品${product.basicMotorCode} : ${vc.vcCode} 必须由GCS报价`
              if (error.indexOf(message) == -1) {
                error.push(message);
              }
            }
            return;
          }
          // 标准VC匹配不到价格时不允许提交，需要将其转为自定义VC才可以，包含通过报价创建的价格，在有效期内的
          // hongduo.liu - 20260623183514000 - vc.vcType数据错误导致选型无法完成，临时处理方法，数据修正后删除
          const hasDqQuotation = vc.dqProductVc?.dqProduct?.technologyQuotation?.domesticQuotationNumber != undefined
            && vc.dqProductVc?.dqProduct?.technologyQuotation?.domesticQuotationNumber != null;
          const isQuotedNonStandardVc = (vc.vcType != VcType.Standard || (vc.vcCode.startsWith('999') && vc.vcCode.length == 9)) && hasDqQuotation;
          if (isQuotedNonStandardVc) {
            // 面价/打折方式等已在 syncDomesticQuotationToFacePrice 中同步
          }
          else {
            // 所有地方都没有价格，必须GCS提供
            // 不生成报价不能进行下一步。给一条提示说”该选型包含未报价产品，必须由GCS报价“
            // needQutation = true;
            // 自定义VC采用警告提示，其余类型VC采用错误提示
            if (vc.vcType == VcType.Custom) {
              if (vc.unitPrice === null) {
                const message = `该选型包含未报价产品${product.basicMotorCode} : ${isGranted("Role.CP") || isGranted("Role.Sales") ? "999" : vc.vcCode}, 必须由GCS报价`
                if (warn.indexOf(message) == -1) {
                  warn.push(message);
                }
              }
              mVcPriceIsNull = true;
            } else {
              const message = `该选型包含未报价产品${product.basicMotorCode} : ${vc.vcCode} 必须由GCS报价`
              if (error.indexOf(message) == -1) {
                // 清空标准VC的价格信息
                vc.unitPrice = null;
                error.push(message);
              }
            }
          }
        } else if (vc.unitPriceResult === "S") {
          // VC 是电机自带的，不要钱，其实也不需要手动添加
          // 提示一条警告信息，告诉用户这个vc电机自带了，不用选（但是用户选上也没有关系）
          error.push("VC " + vc.vcCode + " 已经被电机 " + product.basicMotorCode + "默认包含")
        } else if (vc.unitPriceResult === "N/A" || vc.unitPriceResult === "NA") {
          // VC 对裸机不可选，需要提示用户
          // 如果到了这里，用户不能进行下一步，必须返回上一步把这个VC干掉才能继续
          error.push("VC " + vc.vcCode + " 对于电机 " + product.basicMotorCode + "不可选，请返回删除")
        } else if (vc.unitPriceResult === "M" && vc.unitPrice === null) {
          // 这种VC 需要用户自己写价格，比如船检费。且用户尚未填写价格
          error.push(`请填写 NO.${product.serialNo} ` + product.basicMotorCode + ":" + vc.vcCode + " 的价格");
          mVcPriceIsNull = true;
        } else if (vc.unitPriceResult === "Y") {
          // 匹配到了价格，赋值
          // vc.unitPrice = VCUnit.unitPrice;
        }
      })
    })

    //构建面价传入dto
    const facePriceProuctTotal: FacePriceMatchingProductInPutDto[] = [];
    const facePriceVcTotal: FacePriceMatchingProductInPutDto[] = [];

    this.inventoryInfo.products.filter(x => x.source != ProdcutAndVcSource.Import).forEach(p => {
      facePriceProuctTotal.push({
        id: p.id,
        unitPrice: p.unitPrice,
        unitPriceResult: p.unitPriceResult
      } as FacePriceMatchingProductInPutDto);
      p.vc.forEach(v => {
        const unitPrice = this.normalizePriceValue(v.unitPrice);
        facePriceVcTotal.push({
          id: v.id,
          unitPrice: unitPrice ?? v.unitPrice,
          unitPriceResult: v.unitPriceResult,
          vcProductCode: v.vcProductCode,
          unitPriceType: v.discountType === undefined || v.discountType === null || v.discountType === ''
            ? v.discountType
            : Number(v.discountType),
        } as FacePriceMatchingProductInPutDto);
      })
    });

    //往数据库写入面价
    await this.lec.facePriceMatching({
      products: facePriceProuctTotal,
      vcs: facePriceVcTotal
    } as FacePriceMatchingInPutDto);

    return {
      warn: warn,
      error: error,
      mVcPriceIsNull: mVcPriceIsNull
    }
    // Object.assign(this.inventoryInfo,data);
  }

  //将选型状态设置成已报价
  @action
  async ModelQuote() {
    const modelQuoteAdd = await this.lec.modelQuote(this.inventoryInfo.id);
    await this.getDetails(this.inventoryInfo.id);
    return modelQuoteAdd;
  }

  //进入报价获取折扣
  @action initDefaultMultiplier = async () => {
    const getCusDetailOutput = await new CustomerInfosServiceProxy().getCusDetail(this.inventoryInfo.clientID);
    const newproducts = [...this.inventoryInfo.products];
    newproducts.forEach(p => {
      if (p.defaultMultiplier === 0 || p.defaultMultiplier === null || p.defaultMultiplier === undefined) {
        if (p.source == ProdcutAndVcSource.CustomerCode) {
          p.defaultMultiplier = getCusDetailOutput.customerMultiplierDefaultMultiplier;
        } else {
          if (p.jinCategoryCode && p.jinCategoryCode != "" && p.jinVersion && p.jinVersion != "") {
            p.defaultMultiplier = getCusDetailOutput.customerMultiplierDefaultMultiplier;
          } else {
            const key = Object.keys(getCusDetailOutput.customerMultiplierSeriesMultiplier).find(key => p.basicMotorSries == key);
            if (key) {
              p.defaultMultiplier = getCusDetailOutput.customerMultiplierSeriesMultiplier[key];
            }
            else {
              if (p.defaultMultiplier == 0) {
                p.defaultMultiplier = getCusDetailOutput.customerMultiplierDefaultMultiplier;
              }
            }
          }
        }
      }
      if (!!p.jinCategoryCode && p.defaultMultiplier == getCusDetailOutput.customerMultiplierDefaultMultiplier) p.defaultMultiplier = 1;
      // debugger;
      // if(p.precalID != null || this.inventoryInfo.status === LectoTypeStatus.销售帮助申请折扣中){

      // }
      // if(p.precalID != null || this.inventoryInfo.status === LectoTypeStatus.销售帮助申请折扣中){
      //   const key = Object.keys(getCusDetailOutput.customerMultiplierSeriesMultiplier).find(key => p.basicMotorSries.startsWith(key));
      //   if (key) {
      //     p.defaultMultiplier = getCusDetailOutput.customerMultiplierSeriesMultiplier[key];
      //   }
      // }else{
      //   p.defaultMultiplier = getCusDetailOutput.customerMultiplierDefaultMultiplier;
      //   const key = Object.keys(getCusDetailOutput.customerMultiplierSeriesMultiplier).find(key => p.basicMotorSries.startsWith(key));
      //   if (key) {
      //     p.defaultMultiplier = getCusDetailOutput.customerMultiplierSeriesMultiplier[key];
      //   }
      //   //期望折扣=默认折扣
      //   p.expectMultiplier = p.defaultMultiplier;
      //   //默认折扣类型
      //   p.multipilerType = MultipilerType.系数折扣;
      // }
      //默认折扣类型
      // p.multipilerType = MultipilerType.系数折扣;
      // 数量为 0 时改为 1，避免单价/总价 NaN，后续传值也按 1
      if (!p.numberOfProduct) {
        p.numberOfProduct = 1;
      }
      //根据期望折扣 设置单价/总价
      setexpectMultiplier(p);
    });
    this.inventoryInfo.products = newproducts;
  }
  @action updateInternalText = (id, internalText) => {
    const newproducts = [...this.inventoryInfo.products];
    newproducts.find(p => p.id === id).internalText = internalText;
    this.inventoryInfo.products = newproducts;
  }
  @action
  async AddCustomProduct(data: AddCustomProductInPutDto) {
    data.lectoTypeId = this.inventoryInfo.id
    if (this.currentSelectRows != null && this.currentSelectRows.length == 1) {
      data.serialNo = this.currentSelectRow.serialNo + 1
    }
    await this.ltpsp.addCustomProduct(data);
    notification.success({ message: '自定义主机添加成功' })
    await this.getDetails(this.inventoryInfo.id);
  }
  @action
  async UpdateCustomProduct(data: AddCustomProductInPutDto) {
    data.lectoTypeId = this.inventoryInfo.id
    // if (this.currentSelectRows != null && this.currentSelectRows.length == 1) {
    //   data.serialNo = this.currentSelectRow.serialNo + 1
    // }
    await this.ltpsp.updateCustomProduct(data);
    notification.success({ message: '自定义主机更新成功' })
    await this.getDetails(this.inventoryInfo.id);
  }

  @action
  async AddImportProduct(data: AddImportProductInputDto) {
    data.lectoTypeId = this.inventoryInfo.id;
    if (this.currentSelectRows != null && this.currentSelectRows.length == 1) {
      data.serialNo = this.currentSelectRow.serialNo + 1
    }
    await this.ltpsp.addImportProduct(data).then(() => {
      notification.success({ message: '添加成功' })
      this.getDetails(this.inventoryInfo.id);
    }).catch(() => {
      return Promise.reject(false);
    })
  }

  @action
  async updateImportProduct(productId, data: UpdateImportProductInputDto) {
    await this.ltpsp.updateImportProduct(productId, data).then(() => {
      notification.success({ message: '更新成功' })
      this.getDetails(this.inventoryInfo.id);
    }).catch(() => {
      return Promise.reject(false);
    })
  }

  @action
  async AddCustomProductVc(data: AddCustomVcInputDto) {
    await this.ltpvsp.addCustomVc(this.currentSelectRows.map(x => x.id), data);
    notification.success({ message: '自定义VC添加成功' })
    await this.getDetails(this.inventoryInfo.id);
  }

  @action
  async UpdateCustomVc(lectoTypeProductVcId: string, data: AddCustomVcInputDto) {
    await this.ltpvsp.updateCustomVc(lectoTypeProductVcId, data);
    notification.success({ message: '自定义VC更新成功' })
    await this.getDetails(this.inventoryInfo.id);
  }

  //写入pre-cal号
  @action
  async SetPReCalNumber(id: string, precalID: string, precalIDSoucre: string) {
    await this.lec.setPReCalNumber({
      id: id,
      precalID: precalID,
      precalIDSoucre: precalIDSoucre
    } as SetPReCalNumberInPutDto);
    this.inventoryInfo.specialOfferApplicationNumber = precalID;
    this.inventoryInfo.precalIDSoucre = precalIDSoucre;
  }
  // 下单
  @action
  async ModelCompltet(isStandard: boolean, currencyId?: string) {
    const ofs = new OrderFormServiceProxy();
    const data = GetInventoryOutPutDto.fromJS({ ...this.inventoryInfo });

    data.expectedDeliveryDate = data.expectedDeliveryDate % 1 == 0 ? data.expectedDeliveryDate * 7 : (Math.floor(data.expectedDeliveryDate) * 7 + 4);;
    data.products.forEach(p => {
      p.expectedDeliveryDate = p.expectedDeliveryDate % 1 == 0 ? p.expectedDeliveryDate * 7 : (Math.floor(p.expectedDeliveryDate) * 7 + 4);;
      //判断是否需要计算实际价格
      const listPriceMultiplier = Math.round((p.listPriceMultiplier || 0) * 10000) / 10000;
      const hasJinCategoryCode = p.jinCategoryCode && p.jinCategoryCode.trim() != ' ';
      const shouldShowCal = hasJinCategoryCode && listPriceMultiplier > 0;
      var dqStatus = p.dqProduct?.technologyQuotation?.dqStatus;
      p.vc.forEach(x => {
        if ((x.vcType == VcType.Custom || x.vcType == VcType.Industry) && shouldShowCal && (dqStatus == TechnologyQuotationStatus.ExamineSuccess || dqStatus == TechnologyQuotationStatus.Completed)) {
          x.unitPrice = Math.round(x.unitPrice * listPriceMultiplier);
        }
      })
    });
    if (isStandard) {
      data.sourceId = "SOI";
    } else {
      data.sourceId = "MOI";
    }
    const para = AddOrderFormSmartConfiguratorDto.fromJS({
      ...data,
      isManual: !(data.precalIDSoucre === "PMS"),
      currencyId: currencyId ? currencyId : null,
      projectNo: data.pmsProjectCode
    });

    para.products.map((prod, index) => {
      const product = data.products[index];
      //如果是手动输入的precal，传入期望系数，如果是自动的则传入默认系数
      // if (data.precalIDSoucre === "PMS") {
      //   prod.multiplier = product.defaultMultiplier;
      // } else {
      //   prod.multiplier = product.expectMultiplier;
      // }
      //20220425 任何订单都有可能在此过程中修改变为总价折扣订单
      prod.multiplier = product.expectMultiplier;
      prod.originalMultiplier = product.originalMultiplier;
      if (prod.basicMotorType == BasicMotorType.Import && product.expectMultiplier < product.defaultMultiplier) {
        prod.checkResultOutput.warn.push('该商品系数低于默认系数，请检查审批号');
      }

      // prod.productPrice = product.productPrice;
      // console.log(prod.productPrice);
      prod.price = product.price;
      // console.log(prod.price);
      // // prod.price = product.salesPrice;
      // // console.log(prod.price);
      prod.multipilerType = product.multipilerType;
      //是否新增的pms发起的派生选型
      prod.isNewPMSProduct = product.isNewPMSProduct;
      // 过滤原始vc，只保留isInside不为true的vc
      const filteredVCs = product.vc.filter(v => !v.isInside);
      //添加备注信息
      prod.remark = filteredVCs.map(v => {
        if (v.vcType === VcType.Standard) {
          if (v.vcCode.indexOf('999') != -1) {
            const code2 = v.vcCode.substring(3, v.vcCode.length);
            return '999:' + code2 + ' ' + v.meaning + (v.remark === null ? '' : (' ' + v.remark)) + ';';
          } else {
            if (v.remark) {
              return v.vcCode + ":" + v.remark;
            } else {
              return "";
            }
          }
        } else {
          if (v.remark) {
            return (v.vcType == VcType.Custom ? "999" : v.vcCode) + ":" + v.meaning + ' ' + v.remark;
          } else {
            return (v.vcType == VcType.Custom ? "999" : v.vcCode) + ':' + v.meaning;
          }
        }
      }).filter(x => x).join(';');

      // M3JP 80-132, 加VC445之后添加备注“ 需去除PTC”
      if (prod.basicMotorSries == "M3JP IE3" && prod.frameSize >= 80 && prod.frameSize <= 132 && prod.vc.filter(x => x.vcCode == "445").length > 0) {
        if (prod.remark)
          prod.remark = prod.remark + ";需去除PTC";
        else
          prod.remark = "需去除PTC";
      }

      if (product.internalText) {
        if (prod.remark)
          prod.remark = prod.remark + ";" + product.internalText;
        else
          prod.remark = product.internalText;
      }
      // 客户化代码
      if (product.source == ProdcutAndVcSource.CustomerCode) {
        prod.remark = !!prod.remark ? [prod.remark, product.remark].join(";") : product.remark;
      }
      // 内含VC填写的备注
      prod.insideVCOpenRemarks = product.insideVCOpenRemarks;

      if (prod.unitPriceResult === "S" || prod.unitPriceResult === "Y") {
        prod.unitPriceType = "1";
      } else if (prod.unitPriceResult === "R" || prod.unitPriceResult === "N/A" || prod.unitPriceResult === null || prod.unitPriceResult === "NULL" || prod.unitPriceResult === "NA") {
        prod.unitPriceType = "2";
        if (data.products[index].dqProduct && data.products[index].dqProduct.technologyQuotation) {
          prod.unitPriceExpiredTime = data.products[index].dqProduct.technologyQuotation.quotationExpiredTime;
        }
      } else if (prod.unitPriceResult === "M") {
        prod.unitPriceType = "3";
      }
      if (prod.basicMotorType == BasicMotorType.Import) {
        prod.technicalConfirmation = product.gssTechnicalConfirmationNumber;
        prod.domesticQuotationNumber = product.gssQuotationNo;
      } else {
        prod.technicalSpecifications = product.technicalSpecification
        prod.domesticQuotationNumber = product.dqProduct?.technologyQuotation.domesticQuotationNumber;
      }
      // prod.technicalConfirmation = product.technicalConfirmation;
      prod.vc = filteredVCs.map(vc => {//prod.vc.map((vcd, index2) => {
        const vcd = VC.fromJS({ ...vc });
        //const vc = product.vc[index2];
        if (vcd.unitPriceResult === "S" || vcd.unitPriceResult === "Y") {
          vcd.unitPriceType = "1";
        } else if (vcd.unitPriceResult === "R" || vcd.unitPriceResult === "N/A" || vcd.unitPriceResult === null || vcd.unitPriceResult === "NULL" || vcd.unitPriceResult === "NA") {
          vcd.unitPriceType = "2";
          //如果是行业VC，并且自带有效期有值，则取自带的，否则则取关联协报的有效期
          if (!(vc.vcType === VcType.Industry && vc.unitPriceExpiredTime != null)) {
            vcd.unitPriceExpiredTime = vc.dqProductVc?.dqProduct.technologyQuotation.quotationExpiredTime;
          }
        } else if (vcd.unitPriceResult === "M") {
          vcd.unitPriceType = "3";
        }
        //增加是否为pms派生选型新增的vc
        vcd.isNewProductVC = vc.isNewProductVC;// product.vc[index2].isNewProductVC;
        return vcd;
      });
    });
    if (para.responsibleSalesCode === "0" || para.responsibleSalesCode === null) {
      const userService = new UserServiceProxy();
      const createUser = await userService.get(this.inventoryInfo.creatorUserId);
      para.responsibleSalesName = createUser.fullName;
      para.responsibleSalesCode = this.inventoryInfo.creatorUserId as unknown as string;
    }
    await ofs.addOrderFormSmartConfigurator(para);
    //移到后端addOrderFormSmartConfigurator中一起执行了防止多次调用数据不同步
    // await this.lec.updateType(this.inventoryInfo.id);
    // // 业务变更，商务用户需要基于客户已完成的选型导出CTO、OEM产品导出模板，在模板中需要获取下单时的售价，因此需要在选型中更新每个产品的售价信息
    // const updatePrice = data.products.map(x => UpdateProductMultiplierDto.fromJS({
    //   lectoTypeProducId: x.id,
    //   defaultMultiplier: x.defaultMultiplier,
    //   expectMultiplier: x.expectMultiplier,
    //   multipilerType: x.multipilerType,
    //   unitPrice: x.unitPrice,
    //   salesPrice: x.price
    // }))
    // console.log(updatePrice)
    // await this.ltpsp.updateProductMultiplier(data.id, updatePrice)
  }

  //请求帮助
  @action
  async NeedHelp(id: string, remark, changeSelectedIds = []) {
    await this.lec.needHelp({ id: id, remark: remark, changeSelectedIds: changeSelectedIds } as HelpLectoType);
  }

  //CP请求销售帮助申请折扣
  @action
  async cPQuotedNeedHelp(remark: string) {
    await this.lec.cPQuotedNeedHelp({
      id: this.inventoryInfo.id,
      products: this.inventoryInfo.products.map(x => {
        return {
          id: x.id,
          expectMultiplier: x.expectMultiplier
        }
      }),
      remark: remark
    } as CPQuotedNeedHelpInPut);
  }

  //帮助完成
  @action
  async helpComplted(id: string, remark: string, fileInfos?: { showName: string }[]) {
    await this.lec.helpCompleted({ id: id, remark: remark, fileInfos: fileInfos ?? [] } as HelpLectoType);
  }

  //销售帮助申请折扣完成
  @action
  async saleHelpDisCountCompleted(remark: string) {
    await this.lec.saleHelpDisCountCompleted({
      id: this.inventoryInfo.id,
      lists: this.inventoryInfo.products.map(x => {
        return {
          id: x.id,
          expectMultiplier: x.expectMultiplier
        }
      }),
      remark: remark
    } as SaleHelpDisCountCompletedInPut);
  }

  @action
  UpdateVCRemark(prodId: string, vcCode: string, remark: string) {
    const prod = this.inventoryInfo.products.find(prod => prod.id == prodId);
    const vc = prod?.vc?.find(vc => vc.vcCode == vcCode)
      ?? prod?.jinVc?.find(vc => vc.vcCode == vcCode);
    if (vc) {
      vc.remark = remark;
    }
  }
  @action
  async SubmitVCRemark() {
    try {
      // SMProduct.toJSON 不含前端字段 jinVc；必须先 stringify 再用内存中的 jinVc 合并，
      // 否则内含 VC（isInside=true，如 066）不会进入 SubmitVCRemart 入参。
      const payload: GetInventoryOutPutDto = JSON.parse(JSON.stringify(this.inventoryInfo));
      (payload.products || []).forEach((product) => {
        const live = this.inventoryInfo.products.find(p => p.id === product.id);
        const jinVcPlain = ((live as any)?.jinVc || []).map((v: SMVC) =>
          typeof (v as any)?.toJSON === 'function' ? (v as any).toJSON() : { ...v }
        );
        // 用 checkResult 的 requiredByCode 回填空 vcCode，便于后端按编码更新备注
        // 外挂 VC 已占用的编码不可再分给空编码内含 VC，否则会覆盖外挂备注（如 004）
        const selectOrInputs = [...(live?.checkResultOutput?.selectOrInput || [])];
        const claimedCodes = new Set<string>();
        (product.vc || []).forEach((v) => {
          if (v?.vcCode && String(v.vcCode).trim() !== '') {
            claimedCodes.add(String(v.vcCode));
          }
        });
        jinVcPlain.forEach((vc) => {
          if (vc?.vcCode && String(vc.vcCode).trim() !== '') {
            claimedCodes.add(String(vc.vcCode));
            return;
          }
          if (!this.isOpenVcShowType(vc?.vcShowType)) return;
          const idx = selectOrInputs.findIndex((s) =>
            s?.requiredByCode
            && !claimedCodes.has(String(s.requiredByCode))
            && (s.showType == null || s.showType === vc.vcShowType)
          );
          const matched = idx >= 0
            ? selectOrInputs.splice(idx, 1)[0]
            : selectOrInputs.find((s) => s?.requiredByCode && !claimedCodes.has(String(s.requiredByCode)));
          if (matched?.requiredByCode) {
            vc.vcCode = matched.requiredByCode;
            claimedCodes.add(String(matched.requiredByCode));
          }
        });
        product.vc = [...(product.vc || []), ...jinVcPlain];
        delete (product as any).jinVc;

        // 同步内含 OpenVC 备注字段（无实体 id 时后端主要依赖此字段）；勿写入外挂 OpenVC
        const insideOpenRemarks = jinVcPlain
          .filter((v) => v?.isInside && this.isOpenVcShowType(v?.vcShowType))
          .map((v) => ({
            vcCode: v.vcCode || '',
            remark: v.remark || '',
            meaning: v.meaning || null,
          }))
          .filter((x) => x.vcCode);
        if (insideOpenRemarks.length > 0) {
          product.insideVCOpenRemarks = JSON.stringify(insideOpenRemarks);
        } else if (live?.insideVCOpenRemarks != null) {
          product.insideVCOpenRemarks = live.insideVCOpenRemarks;
        }

        // 展示态已交换境界字段，回传接口前还原为 GetInventory 原始方向
        this.swapJinProductFields(product);
      });

      // 先落选型侧备注；订单侧 JIN 同步失败不应阻断
      await this.ltpvsp.submitVCRemart(payload);
      await this.submitJinInsideOpenVcRemarks();
      notification.success({ message: '提交成功' })
      await this.getDetails(this.inventoryInfo.id);
    } catch (error) {
      notification.error({ message: '更新失败' })
    }
  }

  /** 订单/变更场景下，批量更新 JIN 内含 OpenVC 备注 */
  private submitJinInsideOpenVcRemarks = async () => {
    const info = this.inventoryInfo;
    const orderChange = !!info.orderChange;
    const orderId = orderChange ? info.orderFormChangeId : info.orderFormId;
    if (!orderId) return;

    const insideVcRelType = orderChange ? InsideVcRelType.Change : InsideVcRelType.Order;

    // 先查已有备注，复用其中的境界代码/版本（勿用标准电机码冒充境界码）
    let existingRemarks: { productBasicMotorId?: string; vcCode?: string | null; jinMototCode?: string | null; jinVersion?: string | null; serialNumber?: number; orderId?: string }[] = [];
    try {
      existingRemarks = await this.jinInsideVcRemarkService.getJINInsideVcRemarkByOrderId(orderId, insideVcRelType) || [];
    } catch {
      existingRemarks = [];
    }
    // 变更单偶发挂在原订单 Id 下，再兜底查一次
    if (existingRemarks.length === 0 && orderChange && info.orderFormId) {
      try {
        existingRemarks = await this.jinInsideVcRemarkService.getJINInsideVcRemarkByOrderId(info.orderFormId, insideVcRelType) || [];
      } catch {
        existingRemarks = [];
      }
    }

    const updates: UpdateJINInsideVcRemarkInputDto[] = [];

    (info.products || []).forEach((product) => {
      if (!product.orderProductId || !product.jinCategoryCode) return;

      const allVcs = this.getProductAllVcs(product);
      const selectOrInputs = [...(product.checkResultOutput?.selectOrInput || [])];
      const claimed = new Set<string>();
      // 外挂编码已占用，空编码内含 VC 不可再占用
      (product.vc || []).forEach((v) => {
        if (!v?.isInside && v?.vcCode && String(v.vcCode).trim() !== '') {
          claimed.add(String(v.vcCode));
        }
      });
      const productExisting = existingRemarks.filter(
        (r) => String(r.productBasicMotorId) === String(product.orderProductId)
          || r.serialNumber === product.serialNo
      );

      // GetInventory 后已对调：basicMotorCode=境界码，jinBasicMotorCode=标准码
      const hasJinDisplaySwap = !!(product.jinBasicMotorCode && product.basicMotorCode);

      allVcs.forEach((vc) => {
        if (!vc?.isInside || !this.isOpenVcShowType(vc.vcShowType)) return;

        let vcCode = (vc.vcCode || '').trim();
        if (!vcCode) {
          const idx = selectOrInputs.findIndex((s) =>
            s?.requiredByCode
            && !claimed.has(String(s.requiredByCode))
            && (s.showType == null || s.showType === vc.vcShowType)
          );
          const matched = idx >= 0
            ? selectOrInputs.splice(idx, 1)[0]
            : selectOrInputs.find((s) => s?.requiredByCode && !claimed.has(String(s.requiredByCode)));
          vcCode = matched?.requiredByCode || '';
          if (vcCode) {
            vc.vcCode = vcCode;
          }
        }
        if (!vcCode) return;
        claimed.add(vcCode);

        const existed = productExisting.find((r) => String(r.vcCode || '') === vcCode)
          || productExisting.find((r) => !r.vcCode);
        // 仅使用可信境界码：已有备注 / 面价境界码 / 展示态境界码。禁止用 dq/标准码兜底。
        const jinMototCode = existed?.jinMototCode
          || product.listPriceJINCode
          || (hasJinDisplaySwap ? product.basicMotorCode : product.jinBasicMotorCode);
        const jinVersion = existed?.jinVersion || product.jinVersion;
        if (!jinMototCode || !jinVersion) return;

        updates.push(UpdateJINInsideVcRemarkInputDto.fromJS({
          orderId: existed?.orderId || orderId,
          productBasicMotorId: product.orderProductId,
          vcCode,
          jinMototCode,
          jinVersion,
          serialNumber: product.serialNo ?? existed?.serialNumber ?? 0,
          insideVcRelType,
          vcRemark: vc.remark ?? '',
        }));
      });
    });

    if (updates.length === 0) return;
    try {
      await this.jinInsideVcRemarkService.batchUpdateJINInsideVcRemark(updates);
    } catch (error: any) {
      const msg = error?.response?.data?.error?.message
        || error?.error?.message
        || error?.message
        || '';
      // 境界面价产品失效时不阻断选型侧已提交的备注
      if (String(msg).includes('境界产品不存在') || String(msg).includes('已失效')) {
        console.warn('BatchUpdateJINInsideVcRemark skipped:', msg, updates);
        return;
      }
      throw error;
    }
  }

  private isOpenVcShowType = (showType?: VCShowType) => {
    return showType === VCShowType.Input
      || showType === VCShowType.Select
      || showType === VCShowType.SelectAndInput;
  }

  //添加行业VC
  @action
  async addIndustry(id: string) {
    await this.ivcService.addIndustryVC(id, this.currentSelectRow.id);
    await this.getDetails(this.inventoryInfo.id);
  }

  //用户自己选择可否打折并保存
  @action
  UpdateVcDisCountType(u: UnitPriceType, id: string | number) {
    const targetId = String(id);
    this.inventoryInfo.products.forEach(p => {
      const applyDiscount = (list?: SMVC[]) => {
        list?.forEach(v => {
          if (String(v.id) === targetId) {
            v.discountType = u;
          }
        });
      };
      applyDiscount(p.vc);
      applyDiscount(p.jinVc);
    });
  }

  //根据level获取机型表
  @action
  async GetBasicMotorseress(level?: number) {
    const request = await this.bmssp.getBasicMotorseress(level);
    return request;
  }

  // 根据主机代码查询参数
  @action
  async getBasicMotorParameterByCode(basicMotorCode?: string) {
    const request = await this.bms.getBasicMotorParameterByCode(basicMotorCode);
    return request;
  }

  @action
  async checkCodeVersion(code: string) {
    const isChanged = await this.lec.checkLectoTypeCodeVersion(code);
    return isChanged;
  }

  /**
   * 调用 GetListPrice，返回标准 VC 的面价匹配结果（vcId -> unitPriceResult）。
   * 用于清除 VC 弹窗判断「错误 VC」，避免选型阶段 inventory 上 unitPriceResult 仍为 null 的误判。
   * 与面价匹配一致：排除进口电机；无 VC 的主机也入参以获取面价。
   */
  @action
  async getStandardVcListPriceResults(): Promise<Map<string, string | null>> {
    const result = new Map<string, string | null>();
    if (!this.inventoryInfo?.products?.length) {
      return result;
    }

    const copyInventoryInfo: GetInventoryOutPutDto = JSON.parse(JSON.stringify(this.inventoryInfo));
    // 与面价匹配一致：排除进口电机；VC 仅保留标准 VC（内含 VC 在 jinVc，不入参）
    copyInventoryInfo.products = copyInventoryInfo.products.filter(x => x.basicMotorType != BasicMotorType.Import);
    copyInventoryInfo.products.forEach(p => {
      p.vc = (p.vc || []).filter(x => x.vcType == VcType.Standard && !x.isInside);
      (p.vc || []).forEach(v => {
        v.unitPrice = 0;
        v.unitPriceResult = null;
      });
    });
    // 无 VC 的主机也要获取面价，不过滤空 vc 产品
    if (copyInventoryInfo.products.length === 0) {
      return result;
    }

    const listPriceDto = ListPriceBasicPriceDto.fromJS(copyInventoryInfo);
    if (copyInventoryInfo.finalCustomerCode) {
      listPriceDto.clientID = copyInventoryInfo.finalCustomerCode;
    }
    listPriceDto.products.forEach(x => {
      x.unitPrice = this.inventoryInfo.orderChange ? x.unitPrice : 0;
      x.unitPriceResult = this.inventoryInfo.orderChange ? x.unitPriceResult : null;
      x.version = x.jinVersion;
    });

    const data = await this.lpbm.getListPrice(listPriceDto);
    data?.products?.forEach(p => {
      p.vc?.forEach(v => {
        if (v.id) {
          result.set(String(v.id), v.unitPriceResult ?? null);
        }
      });
    });
    return result;
  }
}

export default InventoryStore;
